var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wechatpay"}},[_c('div',{ref:"qrcode",attrs:{"id":"qrcode"}}),_c('h3',{staticClass:"uk-h2"},[_vm._v("请微信扫码支付")]),_c('div',{staticStyle:{"height":"200px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }